import React from 'react';
import { Modal as AntModal } from 'antd';
import {
  useStateMethods,
  useStateSelector,
} from '../../providers/stateManager';
import { selectVisible } from '../../utils/selectors';
import { stateKeys } from '../../constants/stateKeys';
import ModalFooter from '../ModalFooter';
import styles from './index.module.scss';

const Modal = ({ children }) => {
  const visible = useStateSelector(selectVisible);

  const { setValue, setState } = useStateMethods();

  const handleCancel = () => {
    setValue(stateKeys.visible, false);
  };

  const afterClose = () => {
    setState((prev) => {
      const prevImages = prev[stateKeys.images];
      const prevFiles = prev[stateKeys.files];

      return {
        ...prev,
        [stateKeys.editComment]: undefined,
        [stateKeys.images]: prevImages.length ? [] : prevImages,
        [stateKeys.files]: prevFiles.length ? [] : prevFiles,
        [stateKeys.text]: '',
      };
    });
  };

  return (
    <AntModal
      width={590}
      visible={visible}
      centered
      className={styles.root}
      footer={<ModalFooter />}
      title="Комментарии"
      destroyOnClose
      maskClosable={false}
      onCancel={handleCancel}
      afterClose={afterClose}
    >
      {children}
    </AntModal>
  );
};

export default Modal;
